import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkArchiveDeEscalation, IClientDetailsStore, IClientDetailsActions } from '../types';

const onArchiveDeEscalation: IThunkArchiveDeEscalation = thunk(
  async ({ setClientDetails }: Actions<IClientDetailsActions>, payload, { getState }) => {
    const localState = getState() as IClientDetailsStore;

    await api.clientDetails.archiveDeEscalationTechnique(payload);

    const deEscalationTechniques = localState.deEscalationTechniques.map(item =>
      item.id !== Number(payload.id) ? item : { ...item, isArchived: true },
    );

    setClientDetails({ deEscalationTechniques });
  },
);

export default onArchiveDeEscalation;
